<template>
  <div :class="{ active: isSelected }" class="tile" @click="$emit('on-click')">
    <div class="tile__label" v-if="hasLabel">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="68"
        height="68"
        viewBox="0 0 68 68"
      >
        <defs>
          <filter
            id="a"
            x="0"
            y="0"
            width="68"
            height="68"
            filterUnits="userSpaceOnUse"
          >
            <feOffset dy="3" input="SourceAlpha" />
            <feGaussianBlur stdDeviation="3" result="b" />
            <feFlood flood-opacity="0.161" />
            <feComposite operator="in" in2="b" />
            <feComposite in="SourceGraphic" />
          </filter>
        </defs>
        <g transform="translate(-15 -389)">
          <g transform="matrix(1, 0, 0, 1, 15, 389)" filter="url(#a)">
            <g
              transform="translate(9 6)"
              fill="#fff"
              stroke="#d2b887"
              stroke-width="3"
            >
              <circle cx="25" cy="25" r="25" stroke="none" />
              <circle cx="25" cy="25" r="23.5" fill="none" />
            </g>
          </g>
          <path
            d="M2.272.02,2.247,4.977a2.968,2.968,0,0,0,.03.45,1.053,1.053,0,0,0,.121.368.618.618,0,0,0,.255.246.89.89,0,0,0,.422.086.9.9,0,0,0,.423-.09.636.636,0,0,0,.258-.249,1.072,1.072,0,0,0,.125-.369,2.981,2.981,0,0,0,.034-.451L3.939.012,6.183,0,6.155,5.561a2.369,2.369,0,0,1-.176.9,1.877,1.877,0,0,1-.543.728,2.64,2.64,0,0,1-.954.483,5.119,5.119,0,0,1-1.417.178,5.081,5.081,0,0,1-1.415-.163A2.63,2.63,0,0,1,.7,7.221,1.782,1.782,0,0,1,.166,6.5,2.372,2.372,0,0,1,0,5.593L.028.032ZM7.534,7.708l.029-5.781L9.5,1.917l0,.835a1.859,1.859,0,0,1,.156-.292,1.341,1.341,0,0,1,.285-.309,1.565,1.565,0,0,1,.455-.25,2.016,2.016,0,0,1,.679-.1,2.6,2.6,0,0,1,.881.122,1.514,1.514,0,0,1,.554.327,1.353,1.353,0,0,1,.308.438,1.805,1.805,0,0,1,.131.461,2.4,2.4,0,0,1,.025.407,1.761,1.761,0,0,0,0,.258L12.952,7.68,11,7.69l.016-3.275V4.151a1.234,1.234,0,0,0-.057-.373.767.767,0,0,0-.2-.323.55.55,0,0,0-.427-.124.659.659,0,0,0-.487.228,1.287,1.287,0,0,0-.243.5,2.96,2.96,0,0,0-.089.627q-.012.33-.014.6L9.489,7.7Zm11.1-1.926a2.37,2.37,0,0,1-.2.974,1.571,1.571,0,0,1-.5.607,1.89,1.89,0,0,1-.75.312,5.077,5.077,0,0,1-.946.087,4.22,4.22,0,0,1-.716-.057,3.5,3.5,0,0,1-.667-.178,2.881,2.881,0,0,1-.57-.288,1.662,1.662,0,0,1-.425-.4l1.021-1.115a1.252,1.252,0,0,0,.532.5,1.9,1.9,0,0,0,.6.184.921.921,0,0,0,.46-.052.305.305,0,0,0,.215-.3.338.338,0,0,0-.191-.329,2.231,2.231,0,0,0-.475-.168l-.619-.151a1.937,1.937,0,0,1-.624-.272A1.54,1.54,0,0,1,14.3,4.6a1.912,1.912,0,0,1-.193-.95,1.679,1.679,0,0,1,.557-1.388,2.853,2.853,0,0,1,1.76-.493,4.633,4.633,0,0,1,.705.046,3.578,3.578,0,0,1,.571.129,2.727,2.727,0,0,1,.427.174,1.765,1.765,0,0,1,.272.169L18.391,3.52l-1.3.007,0-.319a.341.341,0,0,0-.117-.109.618.618,0,0,0-.181-.076,1.128,1.128,0,0,0-.3-.031q-.663,0-.665.4a.318.318,0,0,0,.2.323,2.621,2.621,0,0,0,.528.179l.683.161a2.243,2.243,0,0,1,.682.282,1.6,1.6,0,0,1,.521.536A1.664,1.664,0,0,1,18.636,5.782ZM22.2,7.731a4.113,4.113,0,0,1-1.351-.185,2.02,2.02,0,0,1-.884-.572,2.242,2.242,0,0,1-.476-.965,5.747,5.747,0,0,1-.137-1.373A4.16,4.16,0,0,1,19.541,3.3a2.215,2.215,0,0,1,.555-.893,2.159,2.159,0,0,1,.9-.5,4.425,4.425,0,0,1,1.219-.16,3.461,3.461,0,0,1,1.265.2,1.9,1.9,0,0,1,.836.611,2.542,2.542,0,0,1,.454,1.025A6.577,6.577,0,0,1,24.9,5.014v.3l-3.516.018a1.319,1.319,0,0,0,.093.549.891.891,0,0,0,.233.323.722.722,0,0,0,.3.152,1.1,1.1,0,0,0,.326.026,1,1,0,0,0,.7-.251,1.389,1.389,0,0,0,.312-.513l1.5.893q-.14.21-.317.43a1.845,1.845,0,0,1-.472.4,2.614,2.614,0,0,1-.744.3A4.242,4.242,0,0,1,22.2,7.731Zm.013-4.671a.815.815,0,0,0-.6.228,1.235,1.235,0,0,0-.218.875l1.55-.008a1.317,1.317,0,0,0-.2-.873A.682.682,0,0,0,22.208,3.06Zm3.746-1.228,1.881-.01-.025.8a2.006,2.006,0,0,1,.415-.634.955.955,0,0,1,.712-.273,1.732,1.732,0,0,1,.433.042.9.9,0,0,1,.251.1A.407.407,0,0,1,29.769,2l0,1.539a.809.809,0,0,0-.2-.131,1.343,1.343,0,0,0-.277-.1,1.745,1.745,0,0,0-.427-.042.892.892,0,0,0-.524.14.849.849,0,0,0-.29.37,1.785,1.785,0,0,0-.126.523q-.028.291-.03.6l-.014,2.7-1.956.01ZM.982,12.01l.011-2.1,6.664-.034-.011,2.1-1.9.01L5.7,19.706l-2.856.015L2.886,12Zm7.211-.485L8.2,9.8l2.462-.013-.009,1.72Zm2.458.8-.037,7.357-2.462.013.037-7.357Zm4.213.692a1.108,1.108,0,0,1,.574-.6,2.141,2.141,0,0,1,1.035-.257,3.6,3.6,0,0,1,1.216.19,2.141,2.141,0,0,1,.935.646,3.106,3.106,0,0,1,.592,1.2,6.918,6.918,0,0,1,.2,1.852,6.65,6.65,0,0,1-.226,1.729,2.932,2.932,0,0,1-.6,1.15,2.338,2.338,0,0,1-.976.648,4.015,4.015,0,0,1-1.327.21,2.143,2.143,0,0,1-.741-.1,1.272,1.272,0,0,1-.427-.243.905.905,0,0,1-.257-.362l-.016,3.091-2.475.013.05-9.861,2.448-.013ZM15.8,18a.821.821,0,0,0,.784-.48,3.767,3.767,0,0,0,.246-1.568,3.455,3.455,0,0,0-.25-1.579.815.815,0,0,0-.759-.458q-.966,0-.976,2.047,0,.336.024.7a2.905,2.905,0,0,0,.119.664,1.159,1.159,0,0,0,.283.488A.714.714,0,0,0,15.8,18Zm7.451-5.032a1.108,1.108,0,0,1,.574-.6,2.141,2.141,0,0,1,1.035-.257,3.6,3.6,0,0,1,1.216.19,2.141,2.141,0,0,1,.935.646,3.106,3.106,0,0,1,.592,1.2A6.918,6.918,0,0,1,27.81,16a6.65,6.65,0,0,1-.226,1.729,2.932,2.932,0,0,1-.6,1.15,2.338,2.338,0,0,1-.976.648,4.015,4.015,0,0,1-1.327.21,2.143,2.143,0,0,1-.741-.1,1.272,1.272,0,0,1-.427-.243.905.905,0,0,1-.257-.362l-.016,3.091-2.475.013.05-9.861,2.448-.013ZM24.2,17.96a.821.821,0,0,0,.784-.48,3.767,3.767,0,0,0,.246-1.568,3.455,3.455,0,0,0-.25-1.579.815.815,0,0,0-.759-.458q-.966,0-.976,2.047,0,.336.024.7a2.905,2.905,0,0,0,.119.664,1.159,1.159,0,0,0,.283.488A.714.714,0,0,0,24.2,17.96Z"
            transform="matrix(0.985, -0.174, 0.174, 0.985, 32.893, 412.433)"
            fill="#d2b887"
          />
        </g>
      </svg>
    </div>
    <svg
      v-if="isSelected"
      class="check"
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      viewBox="0 0 28 28"
      xml:space="preserve"
    >
      <g>
        <g id="Ellipse_10-2">
          <circle
            cx="-1"
            cy="4"
            r="14"
            fill="#fff"
            transform="translate(15 10)"
          />
          <path
            class="st1"
            d="M-1 18c-7.7 0-14-6.3-14-14s6.3-14 14-14S13-3.7 13 4 6.7 18-1 18zm0-26C-7.6-8-13-2.6-13 4s5.4 12 12 12 12-5.4 12-12S5.6-8-1-8z"
            transform="translate(15 10)"
          />
        </g>
      </g>
      <path
        class="st1"
        d="M12.6 19.6c-.2 0-.5-.1-.7-.3l-3.6-3.4c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.3 2.1c.6-2.6 2.3-7 6.7-8.1.5-.1 1.1.2 1.2.7.1.5-.2 1.1-.7 1.2-4.9 1.2-5.6 8.2-5.6 8.3 0 .4-.3.7-.6.9h-.4z"
      />
    </svg>

    <Icon class="icon" :keys="iconKeys" :fill="iconFill" v-if="iconKeys" />

    <span class="tile__title" v-html="text"></span>
  </div>
</template>

<script lang="ts">
import { STEP_TILES_LABEL } from '@/config/steps';
import { Options, Vue, prop } from 'vue-class-component';
import Icon from './Icon.vue'

class Props {
  isSelected = prop({
    type: Boolean,
    required: true,
  })
  id = prop({
    type: String,
    required: true,
  })
  text = prop({
    type: String,
    required: true,
  })
  iconKeys = prop({
    type: Object as () => string[],
    required: false
  })
}

@Options({
  emits: ['on-click'],
  components: {
    Icon,
  },
})
export default class Tile extends Vue.props(Props) {
  get iconFill() {
    return this.isSelected === false ? '#0A4073' : '#fff'
  }

  get hasLabel() {
    return STEP_TILES_LABEL.includes(this.id)
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/setup.scss";

.tile {
  font-weight: 400;
  background: $white;
  border-radius: 10px;
  width: 142px;
  height: 142px;
  box-shadow: 0px 3px 14px 0 rgb(0 0 0 / 0.16);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  transition: all 0.2s linear;
  position: relative;
  text-align: center;
  cursor: pointer;

  .check {
    position: absolute;
    fill: $brown;
    width: 30px;
    top: 0;
    transform: translateY(-50%);
    border-radius: 50px;
    box-shadow: 0px 5px 10px rgb(0 0 0 / 0.1);
  }

  .icon {
    width: 30px;
    margin-bottom: $spacing-1;
    fill: $blue-1;
  }

  &__title {
    color: $blue-2;
    font-weight: 500;
    line-height: 18px;
    font-size: 14px;
    padding: 0 12.5%;
    text-align: center;

    ::v-deep(strong) {
      font-weight: bold;
    }
  }

  &__label {
    position: absolute;
    left: -20px;
    top: -20px;
  }

  @media only screen and (min-width: 960px) {
    &:hover {
      background: $brown;
    }
  }

  &.active {
    background: $brown;
    .icon,
    .tile__title {
      color: $white;
      fill: $white;
    }
  }
}
</style>
